import JQueryView from '../../../common/views/jqueryView';

export default class AboutPageView extends JQueryView {
  constructor() {
    super('#sb-site');

    this.scrollfunc();
  }

  scrollfunc() {
    $(window).scroll(() => {
      const $floatingInview = $('.js-floating-inview');
      if (window.scrollY > 100) {
        $floatingInview.addClass('is-active');
      } else {
        $floatingInview.removeClass('is-active');
      }
    });
  }
}
